import { menuHasPageCode } from "./menuPageAccess";

export const FESHEDILEN_FIRMALAR_PATH = "/feshedilen-firmalar";
export const FESHEDILEN_FIRMALAR_PAGE_CODE = "feshedilen-firmalar";

export const menuHasFeshedilenFirmalar = (items) =>
  menuHasPageCode(items, FESHEDILEN_FIRMALAR_PAGE_CODE);

export const ensureFeshedilenFirmalarRoutes = (routeList, allRoutes) => {
  const next = Array.isArray(routeList) ? [...routeList] : [];
  if (!Array.isArray(allRoutes)) return next;
  const route = allRoutes.find(
    (item) => item && item.path === FESHEDILEN_FIRMALAR_PATH
  );
  if (route && !next.some((item) => item.path === route.path)) {
    next.push(route);
  }
  return next;
};
